import React, { useState, useEffect } from 'react';
import swal from "sweetalert";
import "../../Plantillas/Estilos.css";
import Modal from "../../clientes/ClienteModal";
import ReactTable from "react-table";
import matchSorter from 'match-sorter';
import { REGISTRAR_ACTION, EDITAR_ACTION, UNDEFINED_ACTION } from './constants';
import { BotonDelete, BotonEditar } from '../../Plantillas/Botones';
import Form from './Form';
import { notificarMsg, notificarError } from '../../Almacenes/AlmacenNotify';

export default function () {
  const [action, setAction] = useState(UNDEFINED_ACTION);
  const [modalTitle, setModalTitle] = useState("");
  const [currentId, setCurrentId] = useState(null);
  const [modelos, setModelos] = useState([]);
  const [filterEstado, setFilterEstado] = useState("ACTIVO");

  const refreshList = async () => {
    try {
      const req = await fetch(`/api/vidrieria/modelos?estado=${filterEstado}`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Content': 'application/json',
        }
      });

      if (!req.ok) {
        throw new Error();
      }

      const items = await req.json();
      setModelos(items);
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    refreshList();
  }, [filterEstado]);

  const onCreate = () => {
    setCurrentId(undefined);
    setAction(REGISTRAR_ACTION);
    setModalTitle("Registrar Modelo");
  }

  const onEdit = (id) => {
    setCurrentId(id);
    setAction(EDITAR_ACTION);
    setModalTitle("Editar Modelo");
  }

  const onCloseForm = () => {
    setAction(UNDEFINED_ACTION);
    setCurrentId(undefined);
  }

  const onSaveSuccess = () => {
    refreshList();
    onCloseForm();
  }

  const onToggleEstado = async (modelo) => {
    const isActivo = modelo.Estado === "ACTIVO";
    const nuevoEstado = isActivo ? "INACTIVO" : "ACTIVO";
    const actionText = isActivo ? "inactivar" : "activar";
    const actionVerb = isActivo ? "Inactivado" : "Activado";
    
    swal({
      title: "¿Está seguro?",
      text: `El modelo pasará a estado ${nuevoEstado}.`,
      icon: "warning",
      buttons: ["Cancelar", `Sí, ${actionText}`],
      dangerMode: isActivo,
    }).then(async (willConfirm) => {
      if (willConfirm) {
        try {
          const response = await fetch(`/api/vidrieria/modelos/${modelo.IdModelo}`, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ Estado: nuevoEstado })
          });
          if (response.ok) {
            notificarMsg(`El modelo fue ${actionVerb.toLowerCase()} correctamente`);
            refreshList();
          } else {
            notificarError(`No se pudo ${actionText} el modelo`);
          }
        } catch (e) {
          console.error(e);
          notificarError("Ocurrió un error al comunicarse con el servidor");
        }
      }
    });
  }

  const selectedModelo = modelos.find(m => m.IdModelo === currentId);

  return (
    <div className="ventas-fpay-section">
      <div className="mt-3 container">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Modelos Base</h2>
          <div className="d-flex align-items-center">
            <select 
              className="form-control mr-3" 
              style={{ width: '150px' }} 
              value={filterEstado} 
              onChange={e => setFilterEstado(e.target.value)}
            >
              <option value="ACTIVO">Activos</option>
              <option value="INACTIVO">Inactivos</option>
            </select>
            <button
              className="btn btn-outline-primary btn-verde-mfp"
              type="button"
              onClick={onCreate}
            >
              Registrar Modelo
            </button>
          </div>
        </div>
      </div>

      <div className="mt-3 container">
        <ReactTable
          data={modelos}
          filterable
          defaultFilterMethod={(filter, row) =>
            String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
          }
          columns={[
            {
              Header: "Acciones",
              accessor: "IdModelo",
              width: 150,
              filterable: false,
              Cell: (f) => (
                <div align="center">
                  <BotonEditar
                    className="mr-2"
                    onClick={() => onEdit(f.original.IdModelo)}
                    title="Editar"
                  />
                  <button 
                    className={`btn btn-sm text-white ${f.original.Estado === "ACTIVO" ? "btn-danger" : "btn-success"}`}
                    onClick={() => onToggleEstado(f.original)}
                    style={{ fontSize: "0.85rem", padding: "0.2rem 0.5rem" }}
                  >
                    {f.original.Estado === "ACTIVO" ? "Inactivar" : "Activar"}
                  </button>
                </div>
              ),
            },
            {
              Header: "Estado",
              accessor: "Estado",
              width: 120,
              Cell: (f) => (
                <span style={{ color: f.value === "ACTIVO" ? "#388E3C" : "#D32F2F", fontWeight: "500" }}>
                  ● {f.value}
                </span>
              ),
            },
            {
              Header: "Nombre",
              accessor: "Nombre",
              minWidth: 200,
            },
            {
              Header: "Código Barras",
              accessor: "CodigoBarra",
              width: 150,
            },
            {
              Header: "Geometría",
              accessor: "TipoGeometria",
              width: 150,
            }
          ]}
          defaultPageSize={10}
          className="-striped -highlight"
        />
      </div>

      <Modal isOpen={action !== UNDEFINED_ACTION} title={modalTitle} onClose={onCloseForm}>
        <Form
          action={action}
          currentId={currentId}
          modelo={selectedModelo}
          onCancel={onCloseForm}
          onSaveSuccess={onSaveSuccess}
        />
      </Modal>
    </div>
  );
}
